import React from 'react';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import { Link } from 'react-router-dom';
import { useStyles } from '../Styles';

export default function FabButton({ icon, onClick, to }) {
  const classes = useStyles();

  return (
    <></>
    // <Fab
    //   color="primary"
    //   component={Link}
    //   onClick={onClick}
    //   aria-label="add"
    //   className={`${classes.fab} ${icon === "get_app" && classes.fabdownload}`}
    //   to={to}
    // >
    //   <AddIcon />
    // </Fab>
  );
}
